import { observer } from "mobx-react";
import React from "react";

import { useTranslation } from "react-i18next";

import { IHomeAwayTeams } from "@data-types/sport-stats/SportStatsTypes";
import SportStatisticsStore from "@state/stores/offer/statistics/SportStatisticsStore";
import { highlightTeam } from "@utils/offer";
import classnames from "classnames";

import Graph from "./Graph";

export default observer(function EventStatsChart(props: {
	store: SportStatisticsStore;
	homeAwayTeams: IHomeAwayTeams | null;
}) {
	const { t } = useTranslation();

	const setGraphName = (title: string, key: string | null) => {
		const matchStatName = t(title, { defaultValue: "" });

		if (key != null) {
			return `${matchStatName} (${key})`;
		}

		return matchStatName;
	};

	const isWeb = window.innerWidth > 768;

	return (
		<div
			className={classnames("card card--stats", {
				"u-mar--reset": !isWeb,
			})}
		>
			<div className="card__header">
				<div className="card__title card__title--base u-type--wgt--medium u-type--center">
					{t("EVENT.STATISTICS.MATCH_STATISTICS_TITLE")}
				</div>
			</div>

			<div className="card__body u-padd--top--reset">
				{props.store.matchStatisticsChartData.map((data, index) => (
					<Graph
						noBorder
						key={index}
						info={t(data.infoSection, { defaultValue: "" })}
						graphName={setGraphName(data.title, data.key)}
						data={data.data}
						max={data.max}
						removeValues
						matchNames={
							index === 0
								? {
										away: props.homeAwayTeams?.awayTeam,
										home: props.homeAwayTeams?.homeTeam,
									}
								: undefined
						}
						highlightTeam={highlightTeam(data.data)}
					/>
				))}
			</div>
		</div>
	);
});
